import { connect } from 'react-redux'
import ServiceStatusGraph from './ServiceStatusGraph'

const stateToProps = ({ cases }) => ({
  outages: cases.outages,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(ServiceStatusGraph)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Graphs/ServiceStatusGraph/ServiceStatusGraph.container.js